/**
 * Die Ortsvorschlaege fuer jede Maske - an einer Stelle, weil sie in drei
 * Masken stehen (Person, Ereignis, Bild) und dreimal dieselbe Bremse und
 * dieselbe Abfrage nebeneinander genau die Art Doppelpflege waere, die
 * spaeter auseinanderlaeuft.
 *
 * Frueher holte jede Maske einmal die ganze Liste („suche=") und liess das
 * `<datalist>` darin suchen. Das ging, solange es wenige hundert Orte gab.
 * Die API schneidet bei 200 ab - vorher alphabetisch sortiert, also war ab
 * „B" alles unsichtbar, auch die Orte, an denen die halbe Familie haengt.
 * Genau danach hat es ausgesehen: „den Ort gibt es doch, warum finde ich
 * ihn nicht."
 *
 * Jetzt wandert das Getippte an die API, und die sucht im ganzen Pfad und
 * in der Postleitzahl und sortiert die oft benutzten Orte nach vorn. Die
 * Bremse (200 ms) haelt die Abfragen beim Tippen zusammen; `placeholderData`
 * laesst die alte Liste stehen, solange die neue laeuft, sonst flackert das
 * Vorschlagsfeld bei jedem Buchstaben.
 */
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

/** Wie lange nach dem letzten Tastendruck gewartet wird. */
const BREMSE_MS = 200;

export function useOrtsvorschlaege() {
  const [suche, setSuche] = useState("");
  const [gebremst, setGebremst] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setGebremst(suche), BREMSE_MS);
    return () => clearTimeout(t);
  }, [suche]);

  const abfrage = useQuery({
    // Der Suchtext gehoert in den Schluessel, sonst liefert der
    // Zwischenspeicher zu jeder Eingabe die Antwort der ersten.
    queryKey: ["orte", gebremst],
    queryFn: () => api.orte(gebremst),
    placeholderData: (alt) => alt,
  });

  return {
    orte: abfrage.data?.orte ?? [],
    /**
     * Es gibt mehr Treffer, als in der Liste stehen. Die Maske sagt das
     * dazu - sonst ist es wieder derselbe Eindruck („den Ort gibt es doch"),
     * nur mit einer anderen Zahl.
     */
    abgeschnitten: abfrage.data?.abgeschnitten ?? false,
    treffer: abfrage.data?.treffer ?? 0,
    /** In `onChange` des Ortsfeldes aufrufen. */
    tippen: setSuche,
  };
}
